import { useState } from "react";
//import axios from "axios";
import axios from "../config/axiosConfig";

import "../assets/styles/event-doctor-info.css";

interface Props {
  show: boolean;
  onClose: () => void;
  eventId: number;
  eventName: string;
}

const CreateAttendanceDelegateModal = ({
  show,
  onClose,
  eventId,
  eventName,
}: Props) => {
  const [validHours, setValidHours] = useState<number>(4);
  const [customHours, setCustomHours] = useState<number | "">("");
  const [delegateEmail, setDelegateEmail] = useState("");
  const [generatedLink, setGeneratedLink] = useState("");
  const [loading, setLoading] = useState(false);

  if (!show) return null;

  const resolveHours = () =>
    customHours !== "" ? Number(customHours) : validHours;

  const generateLink = async () => {
    setLoading(true);
    try {
      const res = await axios.post(`/org/attendance-access/generate`,
        {
          eventId,
          validHours: resolveHours(),
          delegateEmail,
        }
      );

      setGeneratedLink(res.data.url);
    } catch (e) {
      alert("Failed to generate delegate link");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="modal-backdrop">
      <div className="modal-container">
        <h5>Generate Event Link for doctor Registration </h5>

        <div className="form-group mt-3">
          <label>Event Name</label>
          <input className="form-control" value={eventName} disabled />
        </div>

        <div className="form-group mt-3">
          <label>Delegate Access Validity</label>

          <div>
            <label>
              <input
                type="radio"
                checked={validHours === 2}
                onChange={() => {
                  setValidHours(2);
                  setCustomHours("");
                }}
              />{" "}
              2 Hours
            </label>
          </div>

          <div>
            <label>
              <input
                type="radio"
                checked={validHours === 4}
                onChange={() => {
                  setValidHours(4);
                  setCustomHours("");
                }}
              />{" "}
              4 Hours
            </label>
          </div>

          <div>
            <label>
              <input
                type="radio"
                checked={validHours === 8}
                onChange={() => {
                  setValidHours(8);
                  setCustomHours("");
                }}
              />{" "}
              Full Day
            </label>
          </div>

          <div className="d-flex align-items-center mt-2">
            <input
              type="radio"
              checked={customHours !== ""}
              onChange={() => setCustomHours(1)}
            />
            <span className="ms-2">Custom</span>
            <input
              type="number"
              className="form-control ms-2"
              style={{ width: "80px" }}
              min={1}
              value={customHours}
              onChange={(e) => setCustomHours(Number(e.target.value))}
              disabled={customHours === ""}
            />
            <span className="ms-1">hours</span>
          </div>
        </div>

        <div className="form-group mt-3">
          <label>Optional Email</label>
          <input
            className="form-control"
            placeholder="Eg: user@abc.com"
            value={delegateEmail}
            onChange={(e) => setDelegateEmail(e.target.value)}
          />
        </div>

        {generatedLink && (
          <div className="alert alert-success mt-3">
            <strong>Delegate Link Generated:</strong>
            <div className="d-flex mt-2">
              <input
                className="form-control"
                value={generatedLink}
                readOnly
              />
              <button
                className="btn btn-outline-secondary ms-2"
                onClick={() => navigator.clipboard.writeText(generatedLink)}
              >
                Copy
              </button>
            </div>
          </div>
        )}

        <div className="d-flex justify-content-end mt-4">
          <button className="btn btn-secondary me-2" onClick={onClose}>
            Cancel
          </button>
          {!generatedLink && (
            <button
              className="btn btn-primary"
              onClick={generateLink}
              disabled={loading}
            >
              {loading ? "Generating..." : "Generate Link"}
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default CreateAttendanceDelegateModal;
